var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useParams } from "react-router-dom";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import { Avatar, Box, Button, Stack, Typography } from "@mui/material";
import { Modal } from "../../components/Modal";
import { obterCertidaoBaixa } from "../../services/veiculos.service";
import { Colors } from "../../util/theme";
import { FormButton, FormButtonType } from "../FormButton";
import { SnackbarFeedback } from "../SnackbarFeedback";
import { ViewPdf } from "../ViewPdf";
export var CardCertidaoBaixa = function () {
    var placa = useParams().placa;
    var _a = useState(false), modalBoleto = _a[0], setModalBoleto = _a[1];
    var _b = useState(), erro = _b[0], setErro = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(undefined), base64 = _d[0], setBase64 = _d[1];
    var gerarDocumento = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setErro(undefined);
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    if (!placa) return [3 /*break*/, 3];
                    payload = {
                        placa: placa,
                    };
                    return [4 /*yield*/, obterCertidaoBaixa(payload)];
                case 2:
                    response = _b.sent();
                    setBase64(response.pdf);
                    _b.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_1 = _b.sent();
                    setErro((_a = error_1.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao gerar documento");
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    setModalBoleto(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Stack, __assign({ boxShadow: "1", borderRadius: "0.25rem", mb: "1rem", sx: { backgroundColor: "white" } }, { children: [_jsxs(Stack, __assign({ flexDirection: "row", justifyContent: "space-between", padding: "0.75rem" }, { children: [_jsxs(Stack, __assign({ flexDirection: "row", alignItems: "start", gap: "1rem" }, { children: [_jsx(Avatar, __assign({ sx: {
                                    backgroundColor: Colors.AZUL_GOV,
                                    padding: "0.5rem",
                                } }, { children: _jsx(DescriptionOutlinedIcon, {}) })), _jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "body1", fontSize: "1.125rem", fontWeight: "500" }, { children: "Baixa Definitiva" })), _jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Certid\u00E3o de Baixa Definitiva do Ve\u00EDculo" }))] })] })), _jsx(Button, __assign({ onClick: function () { return setModalBoleto(true); }, variant: "contained" }, { children: "EMITIR DOCUMENTO" }))] })), _jsx(Modal, { open: modalBoleto, onClose: function () { return setModalBoleto(false); }, icon: _jsx(Avatar, __assign({ sx: {
                        bgcolor: Colors.AZUL_GOV,
                        width: "3.25rem",
                        height: "3.25rem",
                        alignSelf: "center",
                    } }, { children: _jsx(RequestQuoteOutlinedIcon, { fontSize: "large" }) })), title: "Emiss\u00E3o de Documento", subTitle: "Voc\u00EA deseja confirmar a emiss\u00E3o do Documento?", buttons: [
                    _jsx(FormButton, { isDisabled: loading, title: "CONFIRMAR", type: FormButtonType.PRIMARY, onClick: gerarDocumento, isLoading: loading }, 0),
                    _jsx(FormButton, { title: "VOLTAR", type: FormButtonType.SECONDARY, onClick: function () { return setModalBoleto(false); } }, 1),
                ], directionButtons: "row-reverse" }), base64 && (_jsx(ViewPdf, { isOpen: !!base64, close: function () { return setBase64(undefined); }, base64: base64, title: "Baixa Definitiva" })), erro && _jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" })] })));
};
